exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".clientInvoiceNotification-04b67{display:flex;flex-direction:column}", ""]);

// Exports
exports.locals = {
	"clientInvoiceNotification": "clientInvoiceNotification-04b67"
};